"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequizPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const use_lazy_promise_1 = require("../../../hook/use-lazy-promise");
const quiz_1 = require("../../../network/quiz");
const fetch_result_renderer_1 = require("../../../component/fetch-result-renderer");
const quiz_container_1 = require("../quiz-container");
const react_router_dom_1 = require("react-router-dom");
const answer_1 = require("../model/answer");
exports.RequizPage = (0, react_1.memo)(() => {
    const { id: passageId } = (0, react_router_dom_1.useParams)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { result, status, error, executeWithVerify } = (0, use_lazy_promise_1.useLazyPromise)(quiz_1.getQuizResult);
    const [searchParams] = (0, react_router_dom_1.useSearchParams)();
    const initialIndex = (0, react_1.useMemo)(() => {
        const questionId = searchParams.get("questionId");
        let index = result === null || result === void 0 ? void 0 : result.questions.findIndex((q) => q.question.id === questionId);
        if (index !== undefined && index >= 0) {
            return index;
        }
        index = result === null || result === void 0 ? void 0 : result.questions.findIndex((question) => {
            return !question.isPerfect;
        });
        if (index !== undefined && index >= 0) {
            return index;
        }
        return 0;
    }, [result === null || result === void 0 ? void 0 : result.questions, searchParams]);
    (0, react_1.useEffect)(() => {
        executeWithVerify(() => {
            if (!passageId) {
                throw new Error("Cannot find passage");
            }
            return [passageId];
        });
    }, [executeWithVerify, passageId]);
    const handleComplete = (0, react_1.useCallback)(() => {
        navigate(`/quiz-result/${passageId}`);
    }, [navigate, passageId]);
    const userAnswers = (0, react_1.useMemo)(() => {
        const answers = new Map();
        result === null || result === void 0 ? void 0 : result.questions.forEach((question) => {
            if (question.userAnswer) {
                answers.set(question.question.id, {
                    answer: question.userAnswer,
                    state: question.isPerfect
                        ? answer_1.AnswerResultState.Correct
                        : answer_1.AnswerResultState.Incorrect,
                });
            }
        });
        return answers;
    }, [result === null || result === void 0 ? void 0 : result.questions]);
    return ((0, jsx_runtime_1.jsx)(fetch_result_renderer_1.FetchResultRenderer, { result: result, status: status, errorMessages: error === null || error === void 0 ? void 0 : error.message, sx: {
            flex: 1,
            width: "100%",
        }, children: (data) => {
            return ((0, jsx_runtime_1.jsx)(quiz_container_1.QuizContainer, { passageId: passageId || "", onComplete: handleComplete, questions: data.questions.map((q) => q.question), initialIndex: initialIndex, userAnswers: userAnswers, skipEnabled: true }));
        } }));
});
exports.RequizPage.displayName = "RequizPage";
exports.default = exports.RequizPage;
